import { render, staticRenderFns } from "./DirectMessagingThreadEntry.vue?vue&type=template&id=2014945f"
import script from "./DirectMessagingThreadEntry.vue?vue&type=script&lang=ts"
export * from "./DirectMessagingThreadEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports